import { CancelOutlined, Replay } from '@mui/icons-material'
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { RejectionReasonDialog } from '../../reject-request/RejectionReasonDialog'

interface Props {
  onReject: (reason: string) => void
  onUnreject: (reason: string) => void
  rejectMode: boolean
  onClose?: () => void
}

export const RejectMenuItem = ({ onReject, onUnreject, rejectMode, onClose }: Props) => {
  const { t } = useTranslation('requests')
  const [isDialogOpen, setDialogOpen] = useState(false)
  const [reason, setReason] = useState('')

  const handleConfirmDialog = () => (rejectMode ? onReject(reason.trim()) : onUnreject(reason.trim()))

  const handleCloseDialog = () => {
    setDialogOpen(false)
    setReason('')
  }

  const handleButtonClick = () => {
    setDialogOpen(true)
    onClose?.()
  }

  return (
    <>
      {rejectMode ? (
        <MenuItem onClick={handleButtonClick}>
          <ListItemIcon>
            <CancelOutlined />
          </ListItemIcon>
          <ListItemText>{t('manage-request.reject')}</ListItemText>
        </MenuItem>
      ) : (
        <MenuItem onClick={handleButtonClick}>
          <ListItemIcon>
            <Replay />
          </ListItemIcon>
          <ListItemText>{t('manage-request.reopen')}</ListItemText>
        </MenuItem>
      )}
      <RejectionReasonDialog
        open={isDialogOpen}
        onClose={handleCloseDialog}
        onConfirm={handleConfirmDialog}
        reason={reason}
        onReasonChange={setReason}
        rejectMode={rejectMode}
      />
    </>
  )
}
